import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { breadcrumbStyles } from "@insite/content-library/Widgets/Basic/Breadcrumbs";
import { css } from "styled-components";


export const breadcrumbStylesExtension = breadcrumbStyles.pageBreadcrumbs = mergeToNew(breadcrumbStyles.pageBreadcrumbs, {
    breadcrumbs: {
        css: css`
            @media print {
                display: none !important;
            }        
        `,
    },
});